import store from '../store';

const prefixedPick = (object, prefix, trimPrefix = true) => {
	return Object.keys(object).reduce((acc, curr) => {
		if (curr.startsWith(prefix)) {
			const key = trimPrefix ? curr.slice(prefix.length) : curr;
			acc[key] = object[curr];
		}
		return acc;
	}, {});
};

const getStoreReport = () => {
	const modules = ['app', 'device', 'error', 'event', 'features', 'player'];

	return modules.reduce((acc, curr) => {
		acc[curr] = prefixedPick(store.getters, `${curr}/`);
		return acc;
	}, {});
};

const getReport = () => {
	const [performanceTiming] = window.performance.getEntriesByType('navigation');

	return {
		device: {
			userAgent: navigator.userAgent,
			memory:    navigator.deviceMemory,
			cpus:      navigator.hardwareConcurrency,
			network:   {
				effectiveType: navigator.connection.effectiveType,
				downlink:      navigator.connection.downlink,
			},
			screen: {
				width:           window.screen.width,
				height:          window.screen.height,
				availableWidth:  window.screen.availWidth,
				availableHeight: window.screen.availHeight,
				pixelRatio:      window.devicePixelRatio,
				maxTouchPoints:  navigator.maxTouchPoints,
				orientation:     {
					type:  screen.orientation?.type,
					angle: screen.orientation?.angle,
				},
			},
		},
		window: {
			width:  window.innerWidth,
			height: window.innerHeight,
		},
		page: {
			url:    window.location.href,
			width:  document.documentElement.scrollWidth,
			height: document.documentElement.scrollHeight,
		},
		metrics: {
			dnsLookupTime:        performanceTiming.domainLookupEnd - performanceTiming.domainLookupStart,
			redirectTime:         performanceTiming.redirectEnd - performanceTiming.redirectStart,
			timeToDOMComplete:    performanceTiming.domComplete,
			timeToDOMInteractive: performanceTiming.domInteractive,
			timeToFirstByte:      performanceTiming.responseStart - performanceTiming.requestStart,
		},
		store: getStoreReport(),
	};
};

export { getReport, getStoreReport };
